import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, BriefcaseIcon, FileTextIcon, UsersIcon, BuildingIcon, HandshakeIcon, WebhookIcon, PlayCircleIcon, ScrollTextIcon, LibraryIcon, CodeIcon } from 'lucide-react';
function MenuItem({
  icon: Icon,
  label,
  to
}: {
  icon: any;
  label: string;
  to: string;
}) {
  return <Link to={to} className="flex items-center gap-3 group/item" data-id="element-395" data-mp="s8ozu3iqtbmn">
      <div className="p-1.5 rounded-md bg-white/5 group-hover/item:bg-violet-electric/20 transition-colors" data-id="element-396" data-mp="4i1m31m5brs6">
        <Icon className="w-4 h-4 text-white/60 group-hover/item:text-violet-electric transition-colors" data-id="element-397" data-mp="3vpxeyfm35xdo" />
      </div>
      <span className="text-white/80 text-sm font-medium group-hover/item:text-white transition-colors" data-id="element-398" data-mp="e96121btncn0">
        {label}
      </span>
    </Link>;
}
export function ResourcesMenu({
  onClose
}: {
  onClose?: () => void;
}) {
  return <div className="fixed top-16 left-1/2 -translate-x-1/2 w-[850px] max-w-[calc(100vw-3rem)] pt-3 z-50" onClick={onClose} data-id="element-399" data-mp="3hveiekstpo3a">
      
      <div className="bg-[#0D0B2E]/95 backdrop-blur-xl border border-white/10 rounded-xl shadow-2xl overflow-hidden" data-id="element-400" data-mp="f4znkdrare9a">
        <div className="grid grid-cols-12 divide-x divide-white/10" data-id="element-401" data-mp="k2j0nac9dkzn">
          {/* Left Column: Intro */}
          <div className="col-span-3 p-6 bg-white/[0.02] flex flex-col justify-between" data-id="element-402" data-mp="ovc8i730x9fy">
            <div data-id="element-403" data-mp="sw4ix3nmtkdt">
              <h3 className="text-white font-semibold text-sm tracking-wide mb-3" data-id="element-404" data-mp="sul1vau5j5az">
                All Resources
              </h3>
              <p className="text-white/60 text-sm leading-relaxed mb-5" data-id="element-405" data-mp="3sdcgvnchrgu3">
                Explore our knowledge hub
              </p>
              <Link to="/resources/reference-guides" className="block rounded-lg border border-violet-link/30 bg-violet-link/[0.08] p-3 hover:border-violet-link/50 transition-colors" data-id="element-406" data-mp="55sa7qkkbjm6">

                <p className="text-[10px] font-bold uppercase tracking-widest text-magenta-hot mb-1.5" data-id="element-407" data-mp="1glpauc1rjrz8">
                  New
                </p>
                <p className="text-white text-xs font-semibold leading-snug mb-1" data-id="element-408" data-mp="1liyxjjxrppjd">
                  Reference Guides
                </p>
                <p className="text-white/60 text-[11px] leading-snug" data-id="element-409" data-mp="3hpj2hxywl6sp">
                  Vendor-neutral primers on ERP, MES, inventory &amp; procurement.
                </p>
              </Link>
            </div>
          </div>

          {/* Middle Column: Resources */}
          <div className="col-span-3 p-6" data-id="element-410" data-mp="3mnkniofw3g6t">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-411" data-mp="2ywxchuaogag1">
              Resources
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-412" data-mp="2tzf0tw59zh4c">
              <MenuItem icon={BookOpenIcon} label="Blog" to="/resources/blog" data-id="element-413" data-mp="38mqcdy1gj14g" />
              <MenuItem icon={BriefcaseIcon} label="Case Studies" to="/resources/case-studies" data-id="element-414" data-mp="38otcxc08kcnf" />
              
              <MenuItem icon={LibraryIcon} label="Reference Guides" to="/resources/reference-guides" data-id="element-415" data-mp="2g6pdnoe0g65n" />

              <MenuItem icon={PlayCircleIcon} label="Demo Videos" to="/resources/demo-videos" data-id="element-416" data-mp="2b7mc4dx8oi2f" />
              
              <MenuItem icon={FileTextIcon} label="Our Thesis" to="/resources/thesis" data-id="element-417" data-mp="qp1z2mnkw0pr" />
              
            </div>
          </div>

          {/* Development Column */}
          <div className="col-span-3 p-6" data-id="element-418" data-mp="vi4wx6ze1wbr">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-419" data-mp="hpx0xhfxi9e4">
              Development
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-420" data-mp="loe9m5ezzrxn">
              <MenuItem icon={WebhookIcon} label="Integrations" to="/resources/integrations" data-id="element-421" data-mp="19ftgmbhpyxf8" />
              
              <MenuItem icon={ScrollTextIcon} label="Changelog" to="/resources/changelog" data-id="element-422" data-mp="1ee392ec27jx5" />
              
            </div>
          </div>

          {/* Right Column: About */}
          <div className="col-span-3 p-6 bg-white/[0.02]" data-id="element-423" data-mp="15dydr2k54bzc">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-424" data-mp="15gkk4yvaolfz">
              About
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-425" data-mp="3q58dedhcw2cp">
              <MenuItem icon={UsersIcon} label="Careers" to="/about/careers" data-id="element-426" data-mp="3q606nhnhdnzt" />
              <MenuItem icon={BuildingIcon} label="About Us" to="/about" data-id="element-427" data-mp="99pv9hn6enun" />
              <MenuItem icon={HandshakeIcon} label="Become A Partner" to="/partners" data-id="element-428" data-mp="4hzh10l4bfxy" />
              
            </div>
          </div>
        </div>
      </div>
    </div>;
}